module.exports = __webpack_public_path__ + "public/SiteIcons/loginClose.svg?9633e013";